export enum ArcGisJobStatus {
  Success = 'esriJobSucceeded',
  Failed = 'esriJobFailed',
  Submitted = 'esriJobSubmitted',
  Executing = 'esriJobExecuting',
}

export interface ArcGisJobModelLike {
  jobId: string;
  jobStatus: ArcGisJobStatus;
  results?: {
    [key: string]: {
      paramUrl: string;
    };
  };
}
